/* =========================================================
   Take Me To Wonder — Shopify theme interactions
   Vanilla JS, no dependencies.
   ========================================================= */
(function () {
  "use strict";

  /* ---------- Mobile drawer ---------- */
  var burger   = document.querySelector("[data-burger]");
  var drawer   = document.querySelector("[data-drawer]");
  var backdrop = document.querySelector("[data-drawer-backdrop]");
  var closeBtn = document.querySelector("[data-drawer-close]");

  function openDrawer()  { if (drawer) drawer.classList.add("open"); if (backdrop) backdrop.classList.add("open"); document.body.style.overflow = "hidden"; }
  function closeDrawer() { if (drawer) drawer.classList.remove("open"); if (backdrop) backdrop.classList.remove("open"); document.body.style.overflow = ""; }

  if (burger)   burger.addEventListener("click", openDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (backdrop) backdrop.addEventListener("click", closeDrawer);

  /* ---------- Hero seal badge shimmer ---------- */
  document.querySelectorAll("[data-badge-wrap]").forEach(function (wrap) {
    var img = wrap.querySelector("img");
    if (!img) return;
    function clear() { wrap.classList.remove("is-loading"); }
    if (img.complete) clear();
    else img.addEventListener("load", clear, { once: true });
  });

  /* ---------- Product sliders (Swiper) ---------- */
  function initSlider(el) {
    if (!window.Swiper || el._swiper) return;
    el._swiper = new Swiper(el, {
      slidesPerView: 2.5,
      spaceBetween: 10,
      grabCursor: true,
      watchOverflow: true,
      pagination: { el: el.querySelector(".swiper-pagination"), clickable: true },
      navigation: {
        prevEl: el.querySelector(".swiper-button-prev"),
        nextEl: el.querySelector(".swiper-button-next")
      },
      breakpoints: {
        540:  { slidesPerView: 2.2, spaceBetween: 16 },
        760:  { slidesPerView: 3,   spaceBetween: 20 },
        1000: { slidesPerView: 4,   spaceBetween: 24 }
      }
    });
  }
  // init only sliders that are visible; hidden ones init when first shown
  document.querySelectorAll("[data-product-slider]").forEach(function (el) {
    if (!el.hasAttribute("hidden")) initSlider(el);
  });

  /* ---------- Category pills (home) — filter the rail in place ---------- */
  document.querySelectorAll("[data-pills]").forEach(function (group) {
    var scope = group.closest(".container") || document;
    var rails = scope.querySelectorAll("[data-cat-group]");

    function show(target) {
      if (!rails.length || !target) return;
      rails.forEach(function (r) {
        var match = r.getAttribute("data-cat-group") === target;
        r.toggleAttribute("hidden", !match);
        if (match) {
          initSlider(r);                  // lazy-init the now-visible slider
          if (r._swiper) r._swiper.update();
        }
      });
    }

    group.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        group.querySelectorAll("button").forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        show(btn.getAttribute("data-target"));
      });
    });
  });

  /* ---------- Accordions (PDP) ---------- */
  document.querySelectorAll(".acc-head").forEach(function (head) {
    head.addEventListener("click", function () {
      var item = head.closest(".acc-item");
      var body = item.querySelector(".acc-body");
      var open = item.classList.toggle("open");
      body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
    });
    // open-by-default items get their height set on load
    var item = head.closest(".acc-item");
    if (item.classList.contains("open")) {
      var body = item.querySelector(".acc-body");
      body.style.maxHeight = body.scrollHeight + "px";
    }
  });

  /* ---------- Quantity stepper (PDP only — cart has its own AJAX stepper) ---------- */
  document.querySelectorAll("[data-qty]").forEach(function (q) {
    if (q.closest("[data-cart-root]")) return; // cart steppers handled below
    var input = q.querySelector("input");
    var minus = q.querySelector("[data-qty-minus]");
    var plus  = q.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener("click", function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* ---------- Live AJAX cart (qty change + remove) ---------- */
  (function () {
    var root = document.querySelector("[data-cart-root]");
    if (!root) return;
    var routeRoot = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/");

    function money(cents) {
      var fmt = window.__moneyFormat || "${{amount}}";
      return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    function rerender(cart) {
      // update each line total
      cart.items.forEach(function (item) {
        var line = root.querySelector('[data-line-total][data-key="' + item.key + '"]');
        if (line) line.textContent = money(item.final_line_price);
        var input = root.querySelector('[data-cart-qty][data-key="' + item.key + '"]');
        if (input) input.value = item.quantity;
      });
      // totals
      var sub = root.querySelector("[data-cart-subtotal]");
      var tot = root.querySelector("[data-cart-total]");
      if (sub) sub.textContent = money(cart.items_subtotal_price);
      if (tot) tot.textContent = money(cart.total_price);
      // header count
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        el.toggleAttribute("hidden", cart.item_count === 0);
      });
      // empty cart → reload to show empty state
      if (cart.item_count === 0) window.location.reload();
    }

    function change(key, qty, rowEl) {
      if (rowEl) rowEl.classList.add("is-updating");
      fetch(routeRoot + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (qty === 0 && rowEl) { rowEl.remove(); }
          rerender(cart);
          if (rowEl) rowEl.classList.remove("is-updating");
        })
        .catch(function () { if (rowEl) rowEl.classList.remove("is-updating"); });
    }

    // +/- steppers
    root.querySelectorAll("[data-cart-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-key");
        var step = parseInt(btn.getAttribute("data-cart-step"), 10);
        var input = root.querySelector('[data-cart-qty][data-key="' + key + '"]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        change(key, next, btn.closest("[data-cart-row]"));
      });
    });

    // direct input edit
    root.querySelectorAll("[data-cart-qty]").forEach(function (input) {
      input.addEventListener("change", function () {
        var key = input.getAttribute("data-key");
        var val = Math.max(0, parseInt(input.value, 10) || 0);
        change(key, val, input.closest("[data-cart-row]"));
      });
    });

    // remove
    root.querySelectorAll("[data-cart-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-key");
        change(key, 0, btn.closest("[data-cart-row]"));
      });
    });
  })();

  /* ---------- PDP thumbnail gallery (desktop) ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main   = gallery.querySelector("[data-gallery-main] img");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
        var img = thumb.querySelector("img");
        var src = img.getAttribute("data-full") || img.getAttribute("src");
        if (main) {
          main.removeAttribute("srcset");
          main.removeAttribute("sizes");
          main.setAttribute("src", src);
        }
      });
    });
  });

  /* ---------- PDP gallery slider (Swiper, mobile) ---------- */
  document.querySelectorAll("[data-gallery-slider]").forEach(function (el) {
    if (!window.Swiper || el._swiper) return;
    el._swiper = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      pagination: { el: el.querySelector(".swiper-pagination"), clickable: true }
    });
  });

  /* ---------- Before / After slider ---------- */
  document.querySelectorAll("[data-ba]").forEach(function (ba) {
    var after  = ba.querySelector(".ba__after");
    var handle = ba.querySelector(".ba__handle");
    if (!after || !handle) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = ba.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = "inset(0 0 0 " + pct + "%)";
      handle.style.left = pct + "%";
    }
    var start = function () { dragging = true; };
    var stop  = function () { dragging = false; };
    var move  = function (e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(x);
    };
    handle.addEventListener("mousedown", start);
    handle.addEventListener("touchstart", start, { passive: true });
    window.addEventListener("mouseup", stop);
    window.addEventListener("touchend", stop);
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: true });
    ba.addEventListener("click", function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      setPos(e.clientX);
    });
  });

  /* ---------- Reviews carousel (centered active, looping, touch) ---------- */
  document.querySelectorAll("[data-reviews]").forEach(function (wrap) {
    var rail    = wrap.querySelector("[data-review-rail]");
    var reviews = Array.prototype.slice.call(wrap.querySelectorAll("[data-review]"));
    var dots    = Array.prototype.slice.call(wrap.querySelectorAll("[data-review-dots] button"));
    var n = reviews.length;
    if (!rail || !n) return;

    var current = 0;
    var STEP = 230;   // horizontal gap between neighbours (px)
    var dragX = 0;    // live drag offset while dragging

    // Shortest circular distance from active to item i (handles loop wrap)
    function circDist(i, active) {
      var d = i - active;
      if (d > n / 2)  d -= n;
      if (d < -n / 2) d += n;
      return d;
    }

    function render() {
      reviews.forEach(function (el, i) {
        var d = circDist(i, current);
        var abs = Math.abs(d);
        // Items more than 2 away are parked off-stage
        var tx = d * STEP + dragX;
        var sc, op, vis;
        if (abs > 2) { sc = 0.6; op = 0; vis = "hidden"; }
        else {
          sc = abs === 0 ? 1 : (abs === 1 ? 0.86 : 0.74);
          op = abs === 0 ? 1 : (abs === 1 ? 0.5 : 0.25);
          vis = "visible";
        }
        el.style.setProperty("--tx", tx + "px");
        el.style.setProperty("--sc", sc);
        el.style.setProperty("--op", op);
        el.style.visibility = vis;
        el.style.zIndex = String(10 - abs);
        el.classList.toggle("active", i === current);
      });
      dots.forEach(function (dt, i) { dt.classList.toggle("active", i === current); });
    }

    // Size the stage to the active item so its product card is never clipped
    function fit() {
      var el = reviews[current];
      if (!el) return;
      // offsetHeight is unaffected by the scale() transform
      var h = el.offsetHeight;
      if (h) rail.style.setProperty("--rail-h", (h + 8) + "px");
    }

    function go(idx) {
      current = ((idx % n) + n) % n;   // wrap around
      render();
      fit();
    }

    // Dots + click-to-center
    dots.forEach(function (dt, i) { dt.addEventListener("click", function () { go(i); }); });
    reviews.forEach(function (el, i) {
      el.addEventListener("click", function (e) {
        if (i !== current && !dragMoved) { e.preventDefault(); go(i); }
      });
    });

    // ----- Pointer / touch drag -----
    var startX = 0, dragging = false, dragMoved = false;

    function onDown(x) {
      dragging = true; dragMoved = false; startX = x; dragX = 0;
      rail.classList.add("dragging");
    }
    function onMove(x) {
      if (!dragging) return;
      dragX = x - startX;
      if (Math.abs(dragX) > 6) dragMoved = true;
      render();
    }
    function onUp() {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove("dragging");
      var threshold = STEP / 3;
      if (dragX <= -threshold) { dragX = 0; go(current + 1); }
      else if (dragX >= threshold) { dragX = 0; go(current - 1); }
      else { dragX = 0; render(); }
    }

    // Touch
    rail.addEventListener("touchstart", function (e) { onDown(e.touches[0].clientX); }, { passive: true });
    rail.addEventListener("touchmove",  function (e) { onMove(e.touches[0].clientX); }, { passive: true });
    rail.addEventListener("touchend",   onUp);
    // Mouse drag
    rail.addEventListener("mousedown", function (e) { e.preventDefault(); onDown(e.clientX); });
    window.addEventListener("mousemove", function (e) { onMove(e.clientX); });
    window.addEventListener("mouseup", onUp);

    go(0);
    // Refit once images have loaded and on resize (image height is width-dependent)
    window.addEventListener("load", fit);
    window.addEventListener("resize", function () { render(); fit(); });
    rail.querySelectorAll("img").forEach(function (img) {
      if (!img.complete) img.addEventListener("load", fit, { once: true });
    });
  });

  /* ---------- Shoppable lookbook hotspots ---------- */
  var mobileLook = window.matchMedia("(max-width: 759px)");
  document.querySelectorAll("[data-lookbook]").forEach(function (wrap) {
    var hotspots = Array.prototype.slice.call(wrap.querySelectorAll(".lookbook__hotspot"));
    if (!hotspots.length) return;

    var dialog = wrap.querySelector("[data-lookbook-dialog]");
    var supportsDialog = dialog && typeof dialog.showModal === "function";

    function closeAll(except) {
      hotspots.forEach(function (h) { if (h !== except) h.classList.remove("open"); });
    }

    // Mobile: clone the tapped hotspot's card into the dialog and open it modally.
    function openDialog(h) {
      var card = h.querySelector("[data-lookbook-card]");
      if (!card) return;
      dialog.innerHTML = "";
      var clone = card.cloneNode(true);
      clone.classList.add("is-in-dialog");
      dialog.appendChild(clone);
      var dClose = clone.querySelector("[data-lookbook-close]");
      if (dClose) dClose.addEventListener("click", function () { dialog.close(); });
      dialog.showModal();
    }
    if (dialog) {
      // Backdrop tap closes (clicks land on the dialog element itself).
      dialog.addEventListener("click", function (e) {
        if (e.target === dialog) dialog.close();
      });
      dialog.addEventListener("close", function () { dialog.innerHTML = ""; });
    }

    hotspots.forEach(function (h) {
      var dot   = h.querySelector("[data-lookbook-dot]");
      var close = h.querySelector("[data-lookbook-close]");
      if (dot) {
        dot.addEventListener("click", function (e) {
          e.stopPropagation();
          if (mobileLook.matches && supportsDialog) {
            closeAll(null);
            openDialog(h);
            return;
          }
          var isOpen = h.classList.contains("open");
          closeAll(h);
          h.classList.toggle("open", !isOpen);
        });
      }
      if (close) {
        close.addEventListener("click", function (e) {
          e.stopPropagation();
          h.classList.remove("open");
        });
      }
      // Keep clicks inside the card (e.g. the links) from closing it
      var card = h.querySelector("[data-lookbook-card]");
      if (card) card.addEventListener("click", function (e) { e.stopPropagation(); });
    });

    // Click anywhere else closes open (desktop) cards
    document.addEventListener("click", function () { closeAll(null); });
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll(".reveal");
  function revealAll() { revealEls.forEach(function (el) { el.classList.add("in"); }); }

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
    // Safety net: never let content stay hidden if the observer doesn't fire
    // (e.g. very tall pages, programmatic rendering). Reveal everything shortly after load.
    window.addEventListener("load", function () { setTimeout(revealAll, 1200); });
  } else {
    revealAll();
  }

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.toggleAttribute("hidden", cart.item_count === 0);
        });
      })
      .catch(function () {});
  }
  document.addEventListener("DOMContentLoaded", refreshCartCount);

  /* ---------- AJAX add-to-cart on product cards ---------- */
  document.querySelectorAll("[data-card-add]").forEach(function (btn) {
    // update only the text span so the cart icon survives
    var textEl = btn.querySelector(".product-card__add-text") || btn;
    function setLabel(t) { textEl.textContent = t; }

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute("data-variant-id");
      if (!id || btn.classList.contains("is-loading")) return;
      btn.classList.add("is-loading");
      setLabel("Adding…");
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.classList.remove("is-loading");
          btn.classList.add("is-added");
          setLabel("Added ✓");
          refreshCartCount();
          setTimeout(function () { btn.classList.remove("is-added"); setLabel(btn.getAttribute("data-label") || "Add To Cart"); }, 1500);
        })
        .catch(function () { btn.classList.remove("is-loading"); setLabel("Try again"); });
    });
  });

})();
